import React, {useEffect, useState} from 'react';
import globalContext from '../../../../config/context';

import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField/TextField';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 300,
    marginTop: 5,
  },
  comboBox: {
    width: '100%',
    paddingBottom: 10,
    disabled: 'true',
  },
  textField: {
    width: '100%',
    paddingBottom: 10,
  },
}));

const DialogTarget = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{targetPendataan}, {setTargetPendataan}] = useAppContext();
  const {onTarget} = props;

  return (
    <div className={classes.root}>
      <TextField
        id="outlined-basic"
        className={classes.textField}
        label="Target Pendataan"
        variant="outlined"
        type="number"
        value={targetPendataan}
        onChange={(e) => setTargetPendataan(e.target.value)}
      />
    </div>
  );
};

export default DialogTarget;
